<sl-scheduler #absence view="calendar" show-resource-selector="false" show-view-selector="false" (click)="onSchedulerClick($event)">
    <sl-button size="small" class="ml-4" slot="custom-controls" i18n (click)="onAddAbsence()" i18n>Add Absence</sl-button>
</sl-scheduler>